import React, { useEffect, useState } from 'react';

const MultiCarouselScrollbar = ({ carouselState, cssBlock, color }) => {

    const [scrollBarWidth, setScrollBarWidth] = useState(0);
    const [scrollBarLeftPosition, setScrollBarLeftPosition] = useState(0);
    useEffect(() => {
        updateDimensions(carouselState);
    }, []);

    useEffect(() => {
        updateDimensions(carouselState);
    }, [carouselState]);

    const updateDimensions = (carouselState) => {

        const { totalItems, slidesToShow, currentSlide } = carouselState;
        const widthInPercent = (slidesToShow / totalItems) * 100;
        const percentPerItem = 100 / totalItems;
        const leftPositionInPercent = percentPerItem * currentSlide;

        setScrollBarWidth(widthInPercent);
        setScrollBarLeftPosition(leftPositionInPercent)
    }

    return (
        carouselState.totalItems > carouselState.slidesToShow &&
        <div className={`multi-carousel-scrollbar ${cssBlock}__scrollbar-container`}>
            <div className={`multi-carousel-scrollbar__scrollbar ${cssBlock}__scrollbar`} style={{ width: `${scrollBarWidth}%`, left: `${scrollBarLeftPosition}%`, backgroundColor: color }}></div>
            <div className={`multi-carousel-scrollbar__scrollbar-track ${cssBlock}__scrollbar-track`} style={{ backgroundColor: color }}></div>
        </div>

    )
};

export default MultiCarouselScrollbar;